import { useEffect, useState } from 'react';
import { ClockIcon } from '@/assets/icons';
import { storageUtils } from '@/lib/storageUtils';
import styles from './OfferReservationBanner.module.scss';

const OFFER_RESERVATION_HOURS = 24;
const OFFER_RESERVATION_TTL_MS = OFFER_RESERVATION_HOURS * 60 * 60 * 1000;
const DEADLINE_STORAGE_KEY = 'app-redirect-offer-deadline';

function getDeadline(): number {
  const stored = storageUtils.get<number>(DEADLINE_STORAGE_KEY);
  if (stored && stored > Date.now()) {
    return stored;
  }

  const deadline = Date.now() + OFFER_RESERVATION_TTL_MS;
  storageUtils.set(DEADLINE_STORAGE_KEY, deadline, OFFER_RESERVATION_TTL_MS);
  return deadline;
}

function formatRemaining(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [hours, minutes, seconds]
    .map((value) => String(value).padStart(2, '0'))
    .join(':');
}

// Countdown nudging the user to the app before the offer "expires".
export function OfferReservationBanner() {
  const [deadline] = useState(getDeadline);
  const [remainingMs, setRemainingMs] = useState(() => deadline - Date.now());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setRemainingMs(deadline - Date.now());
    }, 1000);

    return () => clearInterval(intervalId);
  }, [deadline]);

  return (
    <div className={styles.root}>
      <ClockIcon className={styles.icon} />
      <p className={styles.text}>
        Ofertă rezervată - expiră în{' '}
        <span className={styles.timer}>{formatRemaining(remainingMs)}</span>
      </p>
    </div>
  );
}
